var darkModeCheckBox = document.querySelector("#feature-dark-mode-switch");

//Check if the element exists first, than add the event listener
darkModeCheckBox && darkModeCheckBox.addEventListener('change', function() {
  console.log("Switch was changed!");
  var darkModeFeatureContainer = document.querySelector("#dark-mode-feature");
  darkModeFeatureContainer.classList.toggle("dark-theme");
  darkModeFeatureContainer.classList.toggle("bkgcolor-black-c1c");
});